import { render, staticRenderFns } from "./PriorityCheck.vue?vue&type=template&id=28c7aea4&"
import script from "./PriorityCheck.vue?vue&type=script&lang=js&"
export * from "./PriorityCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports